import __request__ from "routing/request";
export function status() {
  return __request__("GET", "/system/lbstatus", null, {}, {
    "Accept": ["text/plain"]
  });
}
export function override(status2) {
  return __request__("PUT", `/system/lbstatus/override/${status2}`, null, {}, {
    "Accept": ["application/json"]
  });
}
